<template>
  <!-- TODO: think about un-duplicating similarities between some other component     [DSP-N1QAEm1F]
        {repo}\src\components\form-fields\NumberField.vue
        {repo}\src\components\form-fields\SeachBar\SeachBar.vue
  -->
<TextFieldWarpper :class="{'with-multiline': multiline}">
  <label
    v-if="label"
    :for="name"
    :class="labelClassName"
  >
    {{ label }}
    <template v-if="required"> &#9733;</template>
  </label>
  <component
    :is="multiline ? 'textarea' : 'input'"
    :type="multiline ? null : 'text'"
    :name="name"
    :id="id || name"
    :data-testid="dataTestId || id || name || undefined"
    :maxlength="maxLengthPrepared"
    :value="modelValue"
    @input="emitValue"
    @focusin="$emit('focusin')"
    @focusout="$emit('focusout')"
    :disabled="disabled"
    :style='{
      width: (width || (multiline ? "40ch" : "24ch")),
      height: (height || (multiline ? "11ch" : ""))
    }'
    :class='[fieldClassName]'
  />
</TextFieldWarpper>
</template>

<script lang="ts" setup>
import parseForModelModifiers from './helpers/utils/parseForModelModifiers';
import TextFieldWarpper from '@/components/form-fields/TextFieldWrapper.vue';

const props = defineProps({
  'modelValue': {
  },
  'label': {
    type: String,
    default: ""
  },
  'name': {
    type: String,
    default: ""
  },
  'id': {
    type: String
  },
  'dataTestId': {
    type: String
  },
  'multiline': {
    type: Boolean,
    default: false,
    required: false
  },
  'maxlength': {
    required: false
  },
  'required': {
    type: Boolean,
    default: false
  },
  'modelModifiers': { default: () => ({}) },
  'width': {
    type: String
  },
  'height': {
    type: String
  },
  labelClassName: {
    type: String,
  },
  fieldClassName: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const maxLengthPrepared = props.maxlength ?? (props.multiline ? 200 : 60);

const emit = defineEmits(['update:modelValue','focus', 'focusin', 'focusout'])

function emitValue(event: Event) {
  const target = event.target as HTMLInputElement | HTMLTextAreaElement;
  const value = parseForModelModifiers(props.modelModifiers, target?.value || '');
  emit('update:modelValue', value)
}
</script>

<style lang="scss" scoped>
.with-multiline {
  align-items: flex-start;
  label {
    margin-top: 0rem;
  }
}
</style>